<template>
    <TotemToggleButton
        v-model="hideUncompletedCourses"
        :value="hideUncompletedCourses"
        :label="$t('ReportingFilters.hide_uncompleted_courses')"
        class="filter-toggle"
    />
</template>

<script>
    import filteringHelper from 'components/user/organizationreport/filters/helpers/filteringHelper'
    import { mapGetters } from 'vuex'

    export default {
        name: 'hide-uncompleted-courses',
        mixins: [ filteringHelper ],
        inject: ['tab'],
        computed: {
            ...mapGetters({
                isHideUncompletedCourses: 'ReportsCourses/getToggleHideUncompletedCourses'
            }),
            hideUncompletedCourses: {
                get () {
                    return this.isHideUncompletedCourses
                },
                set (value) {
                    this.$store.dispatch(this.getToggleUncompletedCoursesRoute, value)
                }
            }
        }
    }
</script>
